
<my-navs>
  <ng-container *ngIf="JSONllavesMantenimiento == null">
    <my-nav [navTitle]="'Listado'">
      <app-advancedtable
        [ToolbarSN]=Toolbar
        [breadCrumbItems]=breadCrumbItems
        [WsURL]=strWsURL
        [strSYS02TIP]="strSYS02TIP"
        (AbrirNuevoNav)="abrirNuevoNav($event)"
        *ngIf="componentesExcluidos(strTipo)">
      </app-advancedtable>
  
      <app-advancetable-editable
        [ToolbarSN]=Toolbar
        [breadCrumbItems]=breadCrumbItems
        [WsURL]=strWsURL
        (AbrirNuevoNav)="abrirNuevoNav($event)"
        *ngIf="this.strSYS02TIP =='TED'">
      </app-advancetable-editable>

      <app-lista-editable-sync
        [ToolbarSN]=Toolbar
        [breadCrumbItems]=breadCrumbItems
        [WsURL]=strWsURL
        [strSYS02TIP]="strSYS02TIP"
        [EsExterna]=true      
        [WsLlaves]="JSONllavesMantenimiento"    
        (AbrirNuevoNav)="abrirNuevoNav($event)"
        *ngIf="this.strSYS02TIP =='LSN'">
      </app-lista-editable-sync>  
  
      <!--*ngIf="strTipo != 'NOTIFICACION_COMPONENT' && strTipo != 'ESTUDIANTE_COMPONENT' && strTipo != 'ARCHIVOS_COMPONENT' && strTipo != 'DOCENTENOTAS_COMPONENT' && strTipo != 'DOCENTEAUSENCIAS_COMPONENT' && strTipo != 'DOCENTE_COMPONENT' && strTipo != 'PROFILE_COMPONENT'"> -->
  
      <app-email *ngIf="strTipo == 'NOTIFICACION_COMPONENT'"></app-email>
  
      <app-lazy-heavy *ngIf="strTipo == 'ARCHIVOS_COMPONENT'" type="archivos"></app-lazy-heavy>
  
      <app-servicio-estudiante *ngIf="strTipo == 'ESTUDIANTE_COMPONENT'" [pantalla]="pantalla"></app-servicio-estudiante>
  
      <app-flexmonster *ngIf="strTipo == 'FLEXMONSTER_COMPONENT'"></app-flexmonster>
  
    </my-nav>

  </ng-container>

</my-navs>


<!-- CONTENIDO NAVS -->
<ng-template let-nav="navs" #navsEdit>
</ng-template>

